<div class="container-fluid page">
  <div class="row login-page vh-100">
    <!-- Callback Processing Screen -->
    <div class="col-12">
      <div class="callback-container">
        <div class="callback-content" *ngIf="isProcessing">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">{{ 'users.loginCallback.loading' | translate }}</span>
          </div>
          <h3 class="mt-4">{{ 'users.loginCallback.signingIn' | translate }}</h3>
          <p class="text-muted">{{ 'users.loginCallback.pleaseWait' | translate }}</p>
        </div>

        <div class="callback-content" *ngIf="!isProcessing && errorMessage">
          <div class="error-icon">
            <i class="fa fa-exclamation-triangle text-danger" style="font-size: 48px;"></i>
          </div>
          <h3 class="mt-4 text-danger">{{ 'users.loginCallback.failed' | translate }}</h3>
          <p class="text-muted">{{ errorMessage }}</p>
          <p class="text-muted">{{ 'users.loginCallback.redirecting' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
